<ng-container *transloco="let t">
    <mat-radio-group aria-label="Select an option" (change)="updateSelectedOption($event)" [disabled]="disabled()">
        <div class="radio-buttons-container"
             [ngClass]="{'flex-row': !isFlexDirectionColumn(), 'flex-column': isFlexDirectionColumn()}">
            @for (radioButton of buttonsInfo(); track radioButton.value) {
                <div class="radio-button-option" [ngClass]="{'selected-option': selectedOption === radioButton.value}">
                    <mat-radio-button [value]="radioButton.value" [checked]="selectedOption === radioButton.value">
                        <div class="mat-label">
                            {{ t(radioButton.label.title) }}
                            @if (radioButton.label.text) {
                                <div class="radio-button-text">{{ t(radioButton.label.text) }}</div>
                            }
                        </div>
                    </mat-radio-button>
                </div>
            }
        </div>
    </mat-radio-group>
</ng-container>
